export default defineNuxtRouteMiddleware((_, from) => {
  const { setPreviouslyVisitedPagePath } = useLayout();
  setPreviouslyVisitedPagePath(from.fullPath);
});
